import { afterNextRender, Component, DestroyRef, ElementRef, inject, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { WindowService } from '@shared/services/window.service';
import { AccountSessionExpiredService } from '@app/core/libraries';
import { DeviceFacade } from '@app/store/device';
import { UpdateFacade } from '@app/store/update';
import { HeaderComponent } from './header/header.component';
import { LockComponent } from './lock/lock.component';
import { ScanEmulatorComponent } from './scan-emulator/scan-emulator.component';
import { UpdateBannerComponent } from './update-banner/update-banner.component';
import { WorkstationIndicatorComponent } from './workstation-indicator/workstation-indicator.component';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.css'],
    imports: [RouterModule, HeaderComponent, LockComponent, ScanEmulatorComponent, UpdateBannerComponent, WorkstationIndicatorComponent],

    providers: [AccountSessionExpiredService],
})
export class ShellComponent {
    readonly accountSessionExpiredService = inject(AccountSessionExpiredService);
    protected readonly deviceFacade = inject(DeviceFacade);
    private readonly updateFacade = inject(UpdateFacade);
    private readonly windowService = inject(WindowService);
    private readonly destroyRef = inject(DestroyRef);

    private readonly main = viewChild.required<ElementRef<HTMLElement>>('main');

    protected readonly web = !Capacitor.isNativePlatform();

    constructor() {
        afterNextRender(() => this.windowService.bind(this.main().nativeElement, this.destroyRef));

        // Profile is loaded by the profileLoaded() route guard before the shell renders.

        // The shell's dark header sits under the status bar, so its icons must be light.
        // (Style.Dark = light icons for a dark background.)
        if (Capacitor.isNativePlatform()) {
            StatusBar.setStyle({ style: Style.Dark });
        }

        // Before the check: an update applied at lock reloads the app, and this boot is the
        // other half of that — re-raise the gate the reload wiped, ahead of anything rendering
        // behind it.
        this.updateFacade.restoreLock();

        // Cold start never fires an unlock, so the bridge alone would miss the first check.
        this.updateFacade.check();
    }
}
